let gameBlock = document.querySelector('[data-game]');
if (gameBlock) {
    let demoLink = gameBlock.querySelector('[data-demo-link]');
    let gameBox = gameBlock.querySelector('[data-box]');
    let closeGameBox = gameBlock.querySelector('[data-close]');
    let body = document.querySelector('.page');
    if (demoLink) {
        demoLink.addEventListener('click', () => {
            let gameUrl = demoLink.dataset.url;
            let gameIframe = document.createElement('iframe');
            gameIframe.setAttribute('allowfullscreen', '')
            gameIframe.setAttribute('allow', 'autoplay');
            gameIframe.setAttribute('high', '100%');
            gameIframe.setAttribute('src', gameUrl);
            gameIframe.classList.add('game__iframe');
            gameBox.append(gameIframe);
            gameBox.style.display = 'block';
            gameBox.classList.add('active');
            body.classList.add('scroll-lock');
        })
    }

    closeGameBox.addEventListener('click', () => {
        gameBox.style.display = 'none';
        document.querySelector('.game__iframe').remove();
        body.classList.remove('scroll-lock');
    })
}